<!-- Page Header End -->
<app-pageheader [pageOptions]="pageOptions"></app-pageheader>
<!-- Page Header End -->

<!-- Page content start -->
<div class="container-xxl py-5 wow fadeInUp" data-wow-delay="0.1s">
  <div class="container">
    <!-- Template Card Section Start -->
    <h1 class="mb-4">{{ "responsible" | translate }}</h1>
    <app-contact-card
      [contactCards]="STAFF_DETAILS"
      [totalcount] = "totalcount"
      (onPaginateEvent) = "onPaginateEvent($event)"
    ></app-contact-card>
    <!-- Template Card Section End -->
    <br /><br /><br />
    <!-- Yearly Photo Section Start-->
    <h1 class="mb-4">{{ "yearly_Photo" | translate }}</h1>
    <img
      class="img-fluid"
      src="../../../../assets/img/{{YEAR_PHOTO }}"
      alt=""
    />
    <!-- Yearly Photo Section End-->
  </div>
</div>
<!-- Page content end -->
